import { Grid, GridProps, SxProps, Theme } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';

export const DpGridImages: React.FC<React.PropsWithChildren<GridProps>> = ({
	children,
	...props
}) => (
	<Grid container spacing="20px" {...props}>
		{children}
	</Grid>
);

export const DpCardImage = ({
	src,
	href,
	alt,
	loading,
	priority,
	imagesx,
	...props
}: {
	src: string;
	href?: string;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
	imagesx?: SxProps<Theme>;
}) => (
	<Grid item xs={12} sm={6} {...props}>
		<Linkable href={href}>
			<Img
				src={src}
				alt={alt}
				sx={combineSX([
					{
						width: '100%',
						objectFit: 'cover',
					},
					...(Array.isArray(imagesx) ? imagesx : [imagesx]),
				])}
				loading={loading}
				priority={priority}
			/>
		</Linkable>
	</Grid>
);
